import React from "react"

const PageNotFound = () => {
  return (
    <div style={{ margin: 0, padding: 0, textAlign: "center" }}>
      <h1>404 - Page Not Found</h1>
    </div>
  )
}

export default PageNotFound
